import { Reveal } from "@/lib/motion";
import HowWeWork from "@/sections/HowWeWork";
import { BOOK_REVIEW_MAILTO } from "@/lib/brand";

export default function HowItWorks() {
  return (
    <main data-testid="how-it-works-page" className="pt-32 md:pt-40">
      <section className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="overline">How it works</div>
        </Reveal>
        <Reveal delay={1}>
          <h1 className="mt-6 font-serif-display text-5xl sm:text-6xl lg:text-8xl leading-[0.9] tracking-tightest max-w-5xl">
            A clear path from
            <em className="font-light text-ink-soft"> scattered to structured.</em>
          </h1>
        </Reveal>
        <Reveal delay={2}>
          <p className="mt-10 max-w-2xl text-lg text-ink/75 leading-relaxed">
            Every engagement follows the same three-stage rhythm — look honestly
            at what's there, reimagine a clearer way of working, then help you
            put it in place.
          </p>
        </Reveal>
      </section>

      <HowWeWork />

      <section className="pb-24 md:pb-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <Reveal className="lg:col-span-8">
            <h2 className="font-serif-display text-4xl md:text-6xl tracking-tight leading-[0.95]">
              Ready to start with a
              <em className="font-light text-ink-soft"> Business Systems Review?</em>
            </h2>
          </Reveal>
          <Reveal className="lg:col-span-4 lg:justify-self-end" delay={1}>
            <a
              href={BOOK_REVIEW_MAILTO}
              data-testid="how-it-works-cta"
              className="inline-flex items-center gap-3 bg-brand-red hover:bg-brand-redHover text-white px-7 py-4 text-[13.5px] tracking-[0.06em] font-medium transition-colors"
            >
              Book a Review
              <span aria-hidden>→</span>
            </a>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
